import { render, staticRenderFns } from "./EndView.vue?vue&type=template&id=c77b1c2a&scoped=true"
import script from "./EndView.vue?vue&type=script&lang=ts"
export * from "./EndView.vue?vue&type=script&lang=ts"
import style0 from "./EndView.vue?vue&type=style&index=0&id=c77b1c2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c77b1c2a",
  null
  
)

export default component.exports